import { StandardPinChoice, StandardPinNotification } from '../../../models/standard-pin.model';

const OTHER_PRIORITY = 3;
const COMPANY_PRIORITY = 0;
const NOT_FOUND = -1;
const NUMBER_TYPE = 'number';
const EMPTY_TEXT = '';
const WORD_SEPARATOR = ' ';

export function prioritizeStandardPins<T extends StandardPinNotification>(items: T[]): T[] {
  return items.map((item, index) => ({item: item, index: index}))
    .sort((left, right) => pinPriority(left.item) - pinPriority(right.item) || left.index - right.index)
    .map(entry => entry.item);
}

export function hasStandardPin(item: StandardPinNotification): boolean { return pinPriority(item) < OTHER_PRIORITY; }

function pinPriority(item: StandardPinNotification): number {
  const value = item && item.pinPriority;
  return typeof value === NUMBER_TYPE && value >= COMPANY_PRIORITY && value < OTHER_PRIORITY ? value : OTHER_PRIORITY;
}

export function standardPinChoices(saved: StandardPinChoice[], available: StandardPinChoice[]): StandardPinChoice[] {
  const candidates: {[id: string]: StandardPinChoice} = Object.create(null);
  available.filter(item => !!item && !!item.id).forEach(item => candidates[item.id] = item);
  const savedWithContent = saved.map(item => Object.assign({}, candidates[item.id], item));
  const seen: {[id: string]: boolean} = Object.create(null);
  return savedWithContent.concat(available).filter(item => {
    if (!item || !item.id || seen[item.id]) { return false; }
    seen[item.id] = true;
    return true;
  }).map(withNameTranslations);
}

function withNameTranslations(standard: StandardPinChoice): StandardPinChoice {
  const translation = Object.assign({ru: standard.ruName, en: standard.enName}, standard.nameTranslation);
  return Object.assign({}, standard, {nameTranslation: translation});
}

export function filterStandardPins(choices: StandardPinChoice[], query: string): StandardPinChoice[] {
  const search = (query || EMPTY_TEXT).trim().toLocaleLowerCase();
  return choices.filter(item => standardSearchText(item).indexOf(search) !== NOT_FOUND);
}

function standardSearchText(standard: StandardPinChoice): string {
  const translation = standard.nameTranslation || {};
  return [standard.number, standard.ruName, standard.enName, translation.ru, translation.en, translation.zh]
    .join(WORD_SEPARATOR).toLocaleLowerCase();
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/admin/standards-management/standard-pins.presentation.ts